import { createPinia } from "pinia";
import useLoginStore from "./login";
import useVipStore from "./vip";

export const pinia = createPinia();

export { useLoginStore, useVipStore };
